import CircleAlert from '@/assets/icons/circle-alert.svg?react';
import { cn } from '@/lib/utils';

type PriorityIconProps = {
  className?: string;
};

export function PriorityIcon({ className }: PriorityIconProps) {
  return (
    <CircleAlert
      aria-hidden
      data-testid="priority-icon"
      className={cn('text-chat-message-badgeall-fill size-4 shrink-0', className)}
    />
  );
}
